import React from 'react';
import { DossierSignatoriesContainer } from 'pods/dossier/signatories';
import { ContentLayout } from 'layout';
export const DossierSignatoriesScene = () => {
    return (React.createElement(ContentLayout, null,
        React.createElement(DossierSignatoriesContainer, null)));
};
